module.exports = __webpack_public_path__ + "assets/images/activity_y.54250346.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/activity_y.png
// module id = 671
// module chunks = 1